<template>
    <el-row>
        <el-col :span="6">
            <div style="padding-top: 30px;">
                <Doughnut
                    class="small"
                    :chartData="chartData"
                    :options="options"
                />
            </div>
        </el-col>
        <el-col :span="12">
            <div style="margin-left: 15px">
                <h3 style="font-weight: bold;">
                    {{ $t('table.data.followup.accuracy') }}
                </h3>

                <table>
                    <tr>
                        <th width="50px" style="border-bottom: 1px solid;"></th>
                        <th
                            width="100px"
                            style="text-align: left;border-bottom: 1px solid;"
                        >
                            {{ $t('table.data.followup.type') }}
                        </th>
                        <th
                            width="100px"
                            style="text-align: left;border-bottom: 1px solid;"
                        >
                            {{ $t('table.data.followup.deliveries') }}
                        </th>
                    </tr>
                    <tr v-for="data in tableData">
                        <td width="50px" style="padding-top: 10px">
                            <span
                                class="dot"
                                :style="changeCSS(data.color)"
                            ></span>
                        </td>
                        <td width="100px" style="padding-top: 10px">
                            {{ data.type }}
                        </td>
                        <td
                            width="100px"
                            style="padding-top: 10px;text-align: center"
                        >
                            {{ data.value }}
                        </td>
                    </tr>
                </table>
            </div>
        </el-col>
    </el-row>
</template>

<script>
import Doughnut from './DoughnutChart'

export default {
    name: 'CustomDoughnutChart',
    components: { Doughnut },

    props: {
        deliveryAccuracy: {
            type: Object,
            default: {
                ONTIME: 0,
                TOOEARLY: 0,
                TOOLATE: 0,
            },
        },
    },

    watch: {
        deliveryAccuracy: function(data) {
            this.populateChart(data)
        },
    },

    data: () => ({
        chartData: {},
        options: {
            responsive: true,
            legend: {
                display: false,
            },
        },
        tableData: [],
    }),
    created() {
        this.populateChart(this.deliveryAccuracy)
    },
    methods: {
        changeCSS(val) {
            return 'background-color:' + val
        },
        populateChart(data) {
            this.chartData = {
                labels: [
                    this.$t('table.data.followup.tooLate'),
                    this.$t('table.data.followup.tooLate'),
                    this.$t('table.data.followup.onTime'),
                ],
                datasets: [
                    {
                        backgroundColor: ['#e6f835', '#68f863', '#58a8f8'],
                        data: [data.TOOLATE, data.TOOEARLY, data.ONTIME],
                    },
                ],
            }

            this.tableData = [
                {
                    color: '#e6f835',
                    type: this.$t('table.data.followup.tooLate'),
                    value: data.TOOLATE,
                },
                {
                    color: '#68f863',
                    type: this.$t('table.data.followup.tooEarly'),
                    value: data.TOOEARLY,
                },
                {
                    color: '#58a8f8',
                    type: this.$t('table.data.followup.onTime'),
                    value: data.ONTIME,
                },
            ]
        },
    },
}
</script>

<style>
.small {
    max-width: 120px;
}
.dot {
    height: 15px;
    width: 15px;
    border-radius: 50%;
    display: inline-block;
}

tr:hover {
    background-color: #e9edf6;
}
</style>
